<template> 
    <div> 
        <div class="crumbs" style="margin-left:10px;" hidden="true">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 系统配置
                </el-breadcrumb-item>
                <el-breadcrumb-item>个人信息</el-breadcrumb-item> 
            </el-breadcrumb>
        </div>
        <div class="container">  
            <div style="text-align:left;margin-left:25px;margin-bottom:20px;">
                <el-button  type="primary" size="" icon="el-icon-lx-edit" style="margin-left:30px"   @click="addBind" >编辑</el-button> 
                <el-button  type="danger" style="margin-left:30px"  @click="delMem" >注销账号</el-button> 
            </div>  
            <el-form ref="form" :model="param" size="mini" label-width="0" class="formL" > 
                <p class="formTitle">基本信息</p> 
                <div class='formContain'>
                <el-form-item label="" >
                    <label class="label">账户昵称</label>
                    <span style="margin-left:10px;">{{param.loginName==null?'-':param.loginName}}</span>
                </el-form-item>  
                <el-form-item label="" >
                    <label class="label">手机号码</label>
                    <span style="margin-left:10px;">{{param.phone==null?'-':param.phone}}</span>
                </el-form-item>    
                <el-form-item label="" >
                    <label class="label">登录密码</label>
                    <span style="margin-left:10px;">******</span>
                    <el-button  type="info" plain icon="el-icon-lx-edit" style='margin-left:30px'  @click="addBind2" >修改密码</el-button> 
                </el-form-item>
                <el-form-item label="" >
                    <label class="label">我的邮箱</label>
                    <span style="margin-left:10px;">{{param.email==null?'-':param.email}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label">所在省市</label>
                    <span style="margin-left:10px;">{{param.area==null?'-':param.area}}</span>
                    
                    <!--<span v-if="param.shopBanner==null" style="margin-left:10px;">待上传</span>
                    <img v-else :src="param.shopBanner" style="width:250px;height:100px;"/> -->
                </el-form-item>  
                </div>
            </el-form>
            <el-form ref="form" hidden="true" :model="param" size="mini" label-width="0" class="formR" > 
                <p class="formTitle formTitle2">实名信息</p>  
                <div class='formContain'>
                <el-form-item label="" >
                    <label class="label2">认证类型</label>
                    <span style="margin-left:10px;">{{param.mtype==null?'暂未认证':param.mtype==1?'个人认证':'企业认证'}}</span>
                </el-form-item>  
                <el-form-item label="" v-if="param.mtype==1" >
                    <label class="label2">真实姓名</label>
                    <span style="margin-left:10px;">{{param.realName==null?'':param.realName}}</span>
                </el-form-item>    
                <el-form-item label=""  v-if="param.mtype==1" >
                    <label class="label2">身份证号</label>
                    <span style="margin-left:10px;">{{param.idCard==null?'-':param.idCard}}</span>
                </el-form-item>
                <el-form-item label=""  v-if="param.mtype==2" >
                    <label class="label2">企业名称</label>
                    <span style="margin-left:10px;">{{param.company==null?'-':param.company}}</span>
                </el-form-item> 
                <el-form-item label=""  v-if="param.mtype==2" >
                    <label class="label2">信用代码</label>
                    <span style="margin-left:10px;">{{param.creditCode==null?'-':param.credit}}</span>
                </el-form-item>  
                <el-form-item label="" >
                    <label class="label2">代理编码</label>
                    <span style="margin-left:10px;">{{param.memCode==null?'-':param.memCode}}</span>
                </el-form-item> 
                <el-form-item label="" >
                    <label class="label2">代理密钥</label>
                    <span style="margin-left:10px;">{{param.secret==null?'-':param.secret}}</span>
                </el-form-item>  
                </div>
            </el-form>
            
        </div>

        <el-dialog :close-on-click-modal="false" title="修改密码" :modal-append-to-body='false' :visible.sync="show2" width="350px"  center="true"  >
            <el-form ref="form2" :model="form" label-width="80px">

                <el-form-item label="登录密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="确认密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass2"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form2.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled"   :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> 
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show2 = false">取 消</el-button>
                <el-button type="primary" @click="saveChange2">确 定</el-button>
            </span>
        </el-dialog>   

        <el-dialog :close-on-click-modal="false" title="注销账号" :modal-append-to-body='false' :visible.sync="show3" width="350px"  center="true"  >
            <el-form ref="form2" :model="form3" label-width="80px">    
                <el-form-item label="手机号" >
                    <span>{{param.phone}}</span>
                </el-form-item>  
                <el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form3.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled"   :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> 
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show3 = false"> 取 消 </el-button>
                <el-button type="danger" @click="delMemOper">确定注销</el-button>
            </span>
        </el-dialog>    
 

         
        <el-dialog :close-on-click-modal="false" title="资料修改" :modal-append-to-body='false' :visible.sync="show" width="350px"  center="true"  top="50px">
            <el-form ref="form" :model="form" label-width="80px"> 
                <el-form-item label="手机号码" >
                    <span>{{form.phone}}</span>
                </el-form-item> 
                <el-form-item label="账户昵称" >
                    <el-input  v-model.trim="form.loginName" style="width:150px" placeholder="请填写账户昵称"></el-input>  
                </el-form-item>   
                 <el-form-item label="登录密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="确认密码" >
                    <el-input type="text" @change="changePass()" v-model.trim="form2.loginPass2"   placeholder="请填写登录密码" ></el-input> 
                </el-form-item> 
                <el-form-item label="验证码">
                    <el-input type="number"  v-model.trim="form2.code"  oninput ="value=value.replace(/[^\d]/g,'')" placeholder="验证码" style="width:100px;"></el-input>
                    <el-button  :type="sendSms.type" :disabled="sendSms.disabled"   :style="sendSms.color"  @click="sendCode" >{{sendSms.content}}</el-button> 
                </el-form-item> 
                <el-form-item label="我的邮箱" >
                    <el-input  v-model.trim="form.email"   placeholder="请填写邮箱" ></el-input> 
                </el-form-item>
                <el-form-item label="所在省市" >
                    <el-input  v-model.trim="form.area"   placeholder="请填写联系地址" ></el-input> 
                </el-form-item> 
            </el-form> 
            <span slot="footer" class="dialog-footer">
                <el-button @click="show = false">取 消</el-button>
                <el-button type="primary" @click="saveChange">确 定</el-button>
            </span>
        </el-dialog>    


    </div>
</template>

<script>
import {fetchData,updateData,delMemberDate} from '../../api/memberSet'; 
import {sendNextCode} from '../../api/common';
export default {

    data() {
        return {   
            mid:'',   
            secret:'',
            stationId:'', 
            loginName:'',   
            show:false,
            show2:false,
            show3:false,
            loading:false,
            password:'type',
            smsItem:true,
            form: {  
                aesId:'',
                statusId:'', 
            },   
            form2: {  
                aesId:'',
                statusId:'', 
            },  
            form3:{
                
            }, 
            sendSms:{
                code:'-1', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            loginPass:'******',
            avatar:require('/public/base-img.png') ,
            param:{avatar:'',},
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () {
        this.mid = localStorage.getItem('ms_mid');
        this.secret = localStorage.getItem('ms_secret');
        this.stationId = localStorage.getItem('ms_stationId');  
        this.shopCode = localStorage.getItem('ms_shopCode'); 
        this.param.mid = this.mid;
        this.param.stationId = this.stationId; 
        this.param.shopCode = this.shopCode; 
        //查询列表
        this.getData();  
    },

    methods: {    
         //刷新
        refresh(){
            history.go(0); 
        }, 
        addBind(){
            this.form = this.param;
            if(!this.param.avatar ||this.param.avatar=='' ){
                this.form.avatar = this.avatar;
            }
            this.form.loginPass = this.loginPass;
            this.show = true;
        },
        addBind2(){
            this.param.loginPass =  '';
            this.form2 = this.param;  
            this.show2 = true;
        },
        //发送验证码
        sendCode(){  
            //发送短信按钮倒计时提示  
            var that = this;
            var times = 119;
            this.sendSms.disabled = true;
            this.sendSms.type='info';
            this.sendSms.color ="color:#333";
            this.sendSms.sendFag = "1";
            var timeout = false;
            let codeInterval = window.setInterval(function() { 
                if(timeout){ return; }
                that.sendSms.content='倒计时'+times+'s';
                if((times--) <= 0){
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    window.clearInterval(codeInterval);
                } 
            }, 1000);  

            //发送短信
            this.sendSms.mid = this.mid;
            this.sendSms.stationId = this.stationId; 
            this.sendSms.loginName = this.loginName; 
            this.sendSms.phone = this.param.phone;   
            this.sendSms.code = "-1";
            sendNextCode(this.sendSms).then(res => {
                if(res.code=='200'){ 
                    this.sendSms.code = res.data.code;
                    this.$message.success('发送成功'); 
                    this.getData(this.query);
                }else{ 
                    that.sendSms.type='danger';
                    that.sendSms.content='发送验证码';
                    that.sendSms.disabled = false;
                    that.sendSms.color ="color:#fff";
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                    timeout=true;
                } 
            }); 
        },
        saveChange(){
            // 编辑
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            this.form.shopCode = this.shopCode;   
            if(!this.form.idCard){
                this.$message.error("请输入身份证号");
                return;
            }
            if(this.form.idCard.length!=18){
                this.$message.error("身份证号长度有误");
                return;
            }  
            updateData(this.form).then(res => {  
                if(res.code=='200'){ 
                    this.show = false; 
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.$message.error(res.message);
                }  
            });
        },

        delMem(){
            this.$confirm('注销后您的数据将全部清空，确定要注销账号吗？', '提示', {
                type: 'warning'
            }).then(() => {
                 this.show3 = true;
            }) 
        },
        delMemOper(){
            this.form3.id = this.mid;
            this.form3.stationId = this.stationId; 
            this.form3.phone = this.param.phone;  
            if( !this.form3.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form3.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            }  
            this.show3 = false; 
            delMemberDate(this.form3).then(res => {  
                if(res.code=='200'){ 
                    this.$message.success("您的账号已注销成功！");
                    localStorage.removeItem('ms_username');
                    localStorage.removeItem('ms_realName');
                    localStorage.removeItem('ms_gid');
                    localStorage.removeItem('ms_mid'); 
                    localStorage.removeItem('ms_shopCode'); 
                    localStorage.removeItem('ms_phone'); 
                    localStorage.removeItem('ms_rid'); 
                    localStorage.setItem('ms_token', true);  
                    this.$router.push('/login');  
                }else{
                    this.show3 = true; 
                    this.$message.error(res.message);
                }  
            });
        }, 
        saveChange2(){
            // 编辑
            this.form2.mid = this.mid;
            this.form2.stationId = this.stationId; 
            this.form2.shopCode = this.shopCode; 
            if( !this.form2.loginPass){
                this.$message.error("请输入密码");
                return;
            } 
            if( !this.form2.loginPass2){
                this.$message.error("请再次输入密码");
                return;
            }
            if( this.form2.loginPass != this.form2.loginPass2){
                this.$message.error("两次密码输入不一致");
                return;
            }
            if( !this.form2.code){
                this.$message.error("请输入验证码");
                return;
            }
            if( this.form2.code != this.sendSms.code){
                this.$message.error("验证码不正确");
                return;
            }  
            this.show2 = false; 
            updateData(this.form2).then(res => {  
                if(res.code=='200'){ 
                    this.$message.success(res.message);
                    this.getData(); 
                }else{
                    this.show2 = true; 
                    this.$message.error(res.message);
                }  
            });
        },

        //查询
        getData(){
            // 获取列表数据   
            fetchData(this.param).then(res => {  
                if(res.code=='200'){ 
                    this.param = res.data; 
                }else{
                    this.$message("暂无数据");
                } 
                
            });
        },  
         
        //主图修改
        chageImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.param.avatar = event.target.result;   
            };
            reader.readAsDataURL(file);  
        }, 
        
    }
};
</script>

<style scoped>
.container{
    height: 550px;
}
.formTitle{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    height: 40px;
    background: #1d8cde;
    color: #fff;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
}
.formTitle2{
    background: #ee3838;
}
.formContain{ 
    width:90%;
    padding:15px 5%;
}
.formL{
    width:45%;float:left;
    margin:15px 2%; 
    border:1px solid #20a0ff;
    border-radius: 10px;
}
.formR{
    width:45%;float:right; 
    margin:15px 2%;
    border:1px solid #ea1414;
    border-radius: 10px;
}
.el-message-box{
    width:320px;
}
.handle-del{
    float:right;
    margin-left:15px;
}
 .label{
    background: #1d8cde;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #fff;
    margin-right:15px;
  }
  .label2{
    margin-right:15px;
    background: #ee3838;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #fff;
  }
  @media screen and (max-width:1000px){ 
    .formL{
        width:94%;float:left;
        margin:10px 3%; 
        border:1px solid #20a0ff;
        border-radius: 10px;
    }
    .formR{
        width:94%;float:left; 
        margin:10px 3%;
        border:1px solid #ea1414;
        border-radius: 10px;
    }
  }
</style>
